<template>
    <div>

        <config-main-title>
            Roteamento de Etiquetas
        </config-main-title>

        <div>

            <div class="form-row mb-3">
                <div class="col col-12 col-md-6 d-flex flex-column">
                    <az-input icon="fas fa-search" v-model="search" />
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir
                    </button>
                </div>
            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhuma rota identificada.'" 
                icon="fa-solid fa-signs-post" />
		</div>

        <div v-if="lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <div v-else>
                            <span class="badge badge-secondary" v-if="dado.filtros.length">
                                <i class="fa fa-filter mr-1" aria-hidden="true"></i>
                                {{ dado.filtros.length }}
                            </span>
                        </div>
                    </span>
                </li>
            </div>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ item && item.id_rota_etq ? '' : 'Novo' }}
                            Roteamento de Etiqueta
                            {{ ( item && item.id_rota_etq ) ? '#' + item.id_rota_etq : '' }}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Título"
                                    placeholder="Informar..."
                                    :validate="validate"
                                    required
                                    v-model="item.st_titulo" />
                            </div>

                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Ação"
                                    placeholder="Selecionar..."
                                    type="select"
                                    :optionsList="[
                                        { id: 'B', search: 'Bloquear Impressão' },
                                        { id: 'R', search: 'Servidor de Impressão' },
                                        { id: 'S', search: 'Sufixo para Serv. de Imp.' },                                       
                                    ]"
                                    optionsData="id"
                                    :validate="validate"
                                    required
                                    v-model="item.st_acao" />
                            </div>

                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Servidor de Impressão"
                                    placeholder="Informar..."
                                    type="text"
                                    v-if="item.st_acao != 'B'"
                                    required
                                    :validate="validate"
                                    v-model="item.st_rota" />
                            </div>
                        </div>

                        <!-- Filtros -->
                        <filtro-model class="my-3" v-model="item.filtros" :validate="validate" :opcoes="lista_opcoes_filtro" />

                        <br><br><br><br><br><br><br><br>

                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="cnae" :id="item.id_anexo_requerido" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_anexo_requerido ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import FiltroModel from '../shared/FiltroModel.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
        }
    },

    props: ['id_unidade_operacao'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton,
        FiltroModel
    },

    computed: { 
        lista_opcoes_filtro: function () { 
            let opcoes = [                        
                {id:'App\\azure\\amostraMaterial', search:'Material da Amostra', service: 'amostra_materiais.index'}, 
                {id:'App\\azure\\procedimento', search:'Procedimento', service: 'procedimentos.index'},
                {id:'App\\azure\\unidadeOperacao', search:'Unidade', service:'unidade_operacaos.index'},
            ];

            return opcoes;
        },

        lista_filtros: function () { 

            if ( !this.item ) 
                return [];

            return this.item.filtros.filter(item => !item.excluido);

        },

        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },

        unidade: function () { 
            return this.$util.unidade_operacao(this.id_unidade_operacao);
        },
    },

    methods: { 
        
        incluir () { 
            this.validate = false;

            let item = {
                id_rota_etq: null, 
                fl_ativo: true, 
                st_titulo: "",
                st_acao: "R",
                st_rota: "",
                filtros: [],
            };

            this.editar (item);
        },
        load () { 
            this.$util.load(this, { 
                service:'rota_etqs',
                func: 'index',
                parms: { 
                    cadastro: true, 
                },
            });
        },

        editar (item) { 
            this.validate = false;
            this.item = _.cloneDeep (item);

            $('#edicaoModal').modal('show');
        },

        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'rota_etqs',
                dados: this.item,
                reload: true, 
                modal: 'edicaoModal',
            });
        },

        toggle (item) { 
            this.$util.toggle(this, { 
                service: 'rota_etqs',
                dados: item,
            });
        },
    },

    mounted () { 
        this.load ();

        this.$store.commit('setBreadcrumb',
              [
                { name: "Configurações", path: "/cadastros" },
                { name: "Roteamento de Etiquetas", path: "/config/rota-etq" },
              ]);
    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }

}
</script>
